"use client";

import { useState } from "react";
import { track } from "@/lib/metrika";

// Аккордеон «Часто задаваемые вопросы» — 1:1 со Солнышко (FaqAccordion), акцент
// синий. items приходят из админки (city_pages about-faq, content = JSON [{q,a}]).
const ACCENT = "#0039A6";

interface FaqItem { q: string; a: string }

export default function FaqAccordion({ items, h1, bare = false }: { items: FaqItem[]; h1?: string; bare?: boolean }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div style={bare ? undefined : { maxWidth: 900, margin: "0 auto", padding: "60px 20px 85px" }}>
      {h1 && (
        <>
          <h1 style={{ fontSize: 36, fontWeight: "bold", color: "#000", marginBottom: 0 }}>{h1}</h1>
          <div style={{ width: 80, height: 3, background: ACCENT, margin: "20px 0 30px" }} />
        </>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} style={{ borderBottom: "1px solid #EDEDF0" }}>
              <button
                onClick={() => { if (!isOpen) track("faq_toggle"); setOpenIndex(isOpen ? null : i); }}
                style={{
                  width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "20px 0", background: "none", border: "none", cursor: "pointer",
                  textAlign: "left", fontFamily: "inherit", gap: 16,
                }}
              >
                <span style={{ fontSize: 18, fontWeight: 600, color: "#1E1E2D", lineHeight: 1.4 }}>{item.q}</span>
                <span style={{
                  flexShrink: 0, width: 32, height: 32, borderRadius: "50%",
                  background: isOpen ? ACCENT : "#F5F5F7",
                  display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s",
                }}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ transform: isOpen ? "rotate(45deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                    <line x1="7" y1="1" x2="7" y2="13" stroke={isOpen ? "#fff" : "#666"} strokeWidth="2" strokeLinecap="round" />
                    <line x1="1" y1="7" x2="13" y2="7" stroke={isOpen ? "#fff" : "#666"} strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </span>
              </button>
              <div style={{ maxHeight: isOpen ? 800 : 0, overflow: "hidden", transition: "max-height 0.3s ease" }}>
                <p style={{ fontSize: 16, lineHeight: 1.7, color: "#555", padding: "0 0 20px 0", margin: 0, whiteSpace: "pre-line" }}>{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
